import React from 'react';
import i18n from './../../../i18n/i18n';
import { Button, TextField, Grid, IconButton, Dialog, DialogContent, DialogTitle, Typography, Checkbox, DialogContentText } from '@material-ui/core';
import { wentRight, wentWrong } from "../../../utils/ToastConfig";
import axios from '../../../utils/AxiosWrapper';
import 'react-toastify/dist/ReactToastify.css';
import styles from './machines.module.css';
import ReactSelect from './../../../utils/ReactSelect';

export default class Machines extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            machines: null,
            machineType: [],
            machineList: []
        };
    };

    componentDidMount() {
        axios.get('api/machine/klijent_drop_down')
            .then(res => {
                let listObj = [];
                let list = res.data.data.map(item => {
                    let label = item.naziv;
                    let naziv = item.naziv;
                    let value = item.id;
                    let id_pogonska_masina = item.id;
                    listObj.push({ label, naziv, value, id_pogonska_masina });
                    return { label, value };
                });
                this.setState({ machineType: list, machineList: listObj });
            })
            .catch(() => wentWrong('Something went wrong'))

        if (this.props.activityObj.pogonskeMasine) {
            let temp = this.props.activityObj.pogonskeMasine.map(item => {
                let obj = {};
                obj.label = item.label;
                obj.value = item.value;
                return obj;
            });
            this.setState({ machines: temp });
        }
    };

    getByURL(url, obj) {
        axios.get(`api/${url}`)
            .then(res => this.setState({ [obj]: res.data.data }))
            .catch(error => {
                wentWrong('Something went wrong, please try again!');
                console.log('Error 2 (getByURL): ', error, ', URL: ', url);
            })
    };

    handleAdd = () => {
        if (this.state.machines) {
            if (this.state.machines.length > 0) {
                let machineObj = [];
                let selectedIds = [];

                this.state.machines.map(item => selectedIds.push(item.value));
                this.state.machineList.map((item, i) => { if (selectedIds.includes(item.value)) machineObj.push(item) });

                this.props.handleMachinesObj(machineObj);
            }
            else wentWrong('You have to select at least one machine');
        }
        else wentWrong('You have to select at least one machine');
    };

    render() {
        return (
            <div style={{ padding: 20 }}>
                <Dialog open={this.props.open}
                    onClose={this.props.handleClose}
                    fullWidth={true}
                    disableBackdropClick
                    maxWidth="sm"
                    aria-labelledby="responsive-dialog-title">
                    <DialogTitle disableTypography={true} style={{ background: '#04764e' }} className="responsive-dialog-title">
                        {i18n.t('Add machines')}
                        <IconButton onClick={this.props.handleClose}>
                            <span className="icon-cancel-circle closeIcon" />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <div className={styles.content}>
                            <ReactSelect
                                closeMenuOnSelect={false}
                                isClearable={true}
                                isMulti={true}
                                value={this.state.machines}
                                label={i18n.t('Machine')}
                                maxMenuHeight={320}
                                onChange={(e) => this.setState({ machines: e })}
                                options={this.state.machineList}
                                className="multi-select-activity-form-new"
                                classNamePrefix="select"
                                styles={{ indicatorSeparator: () => { }, dropdownIndicator: defaultStyles => ({ ...defaultStyles, color: 'white' }), clearIndicator: defaultStyles => ({ ...defaultStyles, color: 'white' }) }}
                                placeholder={i18n.t('Select')}
                            />
                        </div>
                        <div className={styles.center}>
                            <Button onClick={() => this.handleAdd()} variant='contained' color='primary' style={{ margin: '0px 20px 10px 0px' }}>{i18n.t('Add')}</Button>
                        </div>
                    </DialogContent>
                </Dialog>
            </div >
        );
    };
};